const INDEX_ITEMS = [
  { title: '热血战斗', count: 326, icon: 'ri-sword-line', desc: '鬼灭之刃、咒术回战、进击的巨人' },
  { title: '奇幻冒险', count: 284, icon: 'ri-compass-3-line', desc: '关于转生史莱姆、Re:Zero、芙莉莲' },
  { title: '校园恋爱', count: 198, icon: 'ri-heart-line', desc: '辉夜大小姐、堀与宫村、青春猪头' },
  { title: '搞笑日常', count: 175, icon: 'ri-emotion-laugh-line', desc: '间谍过家家、龙女仆、齐木楠雄' },
  { title: '科幻机甲', count: 142, icon: 'ri-rocket-line', desc: '怪兽8号、EVA、机动战士高达' },
  { title: '悬疑推理', count: 118, icon: 'ri-search-eye-line', desc: 'Death Note、PSYCHO-PASS、夏日重现' },
  { title: '治愈催泪', count: 96, icon: 'ri-rainbow-line', desc: '未闻花名、紫罗兰永恒花园、Clannad' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">动漫索引</h2>
          <p className="text-sm text-foreground-500">按类型快速查找你喜欢的动漫，总有一部适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-xl cursor-pointer hover:border-primary-300 transition-all duration-200"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-heading text-foreground-950 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-[11px] text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.count}部
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}